<template>
  <div class="navbarComponent">
      <div class="container-sm">
        <div class="inside">
          <div class="case-status">
            <el-row justify="space-between" style="width: 100%;">
              <el-col
                :xl="3"
                :lg="3"
                v-if="!isCaseCompleted && hasPermission('orders', 'edit')"
              >
                <ul>
                  <li>
                    <el-button class="btn-delete" @click="goToEditForm">
                      <span class="pr-5">EDIT</span>
                    </el-button>
                  </li>
                </ul>
              </el-col>
              <el-col :xl="4" :lg="4">
                <ul
                  v-if="
                    getCaseInformation &&
                    getCaseInformation.accession_id &&
                    getCaseInformation.case_id
                  "
                >
                  <li>
                    <h3 class="name">Accession Id</h3>
                  </li>
                  <li>
                    <el-button
                      class="btn-success"
                      @click="goToCaseView(this.getCaseInformation.case_id)"
                    >
                      <span class="pr-5">{{
                        getCaseInformation.accession_id
                      }}</span>
                    </el-button>
                  </li>
                </ul>
              </el-col>
              <el-col :xl="17" :lg="17">
                <ul
                  class="justify-content-end"
                  v-if="getCaseInformation && getCaseInformation.status"
                >
                  <li>
                    <h3 class="name">Order Status</h3>
                  </li>
                  <li>
                    <div
                      class="column-status"
                      v-if="
                        hasPermission('orders', 'pending_rejection') &&
                        getCaseInformation.status
                      "
                    >
                      <div
                        v-if="
                          getCaseInformation.status !== 'COMPLETE' &&
                          getCaseInformation.status !== 'ARCHIVED' &&
                          getCaseInformation.status !== 'PARTIAL'
                        "
                      >
                        <el-dropdown
                          class="status-dropdown"
                          :disabled="
                            getCaseInformation.status === 'COMPLETE' ||
                            getCaseInformation.status == 'PARTIAL'
                          "
                          @command="
                            (command) =>
                              changeStatus(command, getCaseInformation)
                          "
                          trigger="hover"
                          v-if="hasPermission('orders', 'update_status')"
                        >
                          <span class="el-dropdown-link">
                            <el-tag
                              :type="getStatusType(getCaseInformation.status)"
                              style="cursor: pointer"
                            >
                              {{
                                getCaseInformation.status.split("_").join(" ")
                              }}
                            </el-tag>
                          </span>
                          <template #dropdown>
                            <el-dropdown-menu
                              class="status-dropdown-menu center-dropdown"
                            >
                              <span
                                v-if="
                                  getCaseInformation.status &&
                                  (getCaseInformation.status == 'REJECTED' ||
                                    getCaseInformation.status == 'PENDING')
                                "
                              >
                                <el-dropdown-item
                                  command="ACTIVE"
                                  :disabled="
                                    getCaseInformation.status === 'ACTIVE'
                                  "
                                >
                                  ACTIVE
                                </el-dropdown-item>
                              </span>
                              <el-dropdown-item
                                command="PENDING"
                                :disabled="
                                  getCaseInformation.status === 'PENDING'
                                "
                              >
                                PENDING
                              </el-dropdown-item>
                              <el-dropdown-item
                                command="REJECTED"
                                :disabled="
                                  getCaseInformation.status === 'REJECTED'
                                "
                              >
                                REJECTED
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div>
                      <div v-else>
                        <el-tag
                          :type="getStatusType(getCaseInformation.status)"
                          style="cursor: not-allowed"
                        >
                          <span v-if="getCaseInformation.status == 'COMPLETE'">
                            FINALIZED
                          </span>
                          <span
                            v-else-if="getCaseInformation.status == 'PARTIAL'"
                          >
                            PARTIAL
                          </span>
                          <span v-else>
                            {{ getCaseInformation.status.split("_").join(" ") }}
                          </span>
                        </el-tag>
                      </div>
                    </div>

                    <div v-else class="column-status">
                      <el-tag :type="getStatusType(getCaseInformation.status)">
                        {{
                          getCaseInformation.status === "COMPLETE"
                            ? "FINALIZED"
                            : getCaseInformation.status.split("_").join(" ")
                        }}
                      </el-tag>
                    </div>
                  </li>
                  <li v-if="hasPermission('generate_order_barcode', 'view')">
                    <el-button
                      class="pr-5"
                      id="generate-barcode-button"
                      @click="viewBarcode"
                    >
                      PRINT BARCODE
                    </el-button>
                  </li>
                  <li v-if="hasPermission('cases', 'create')">
                    <el-button class="pr-5" @click="viewOrderAudit">
                      Audit
                    </el-button>
                  </li>
                  <li
                    v-if="
                      this.getPendingOrderLogs &&
                      this.getPendingOrderLogs.length
                    "
                  >
                    <el-button
                      @click="drawer = true"
                      class="btn button-with-icon with-blue-bg mini-btn"
                    >
                      Client Response
                    </el-button>
                  </li>
                  <el-drawer
                    v-model="drawer"
                    title="I am the title"
                    :with-header="false"
                  >
                    <div class="drawercloseheader">
                      <el-button @click="closeDrawer" class="drawerclose">
                        <img
                          src="@/assets/images/icons/cases/close-btn.svg"
                          alt="icon"
                          width="30"
                        />
                      </el-button>
                    </div>

                    <ChatApplication
                      @statusUpdated="updateViewOrder"
                    ></ChatApplication>
                  </el-drawer>
                </ul>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  <section
    class="new-case-view case-creation"
    id="single-case-view"
    v-loading="loading"
  >
    
    <div
      class="order-status-reason"
      v-if="
        this.getCaseInformation &&
        this.getCaseInformation.reasons &&
        getCaseInformation.notes
      "
    >
      <div class="container-sm">
        <div class="bg-white">
          <ul>
            <li>
              <h4 class="reason-heading">Reasons :</h4>
            </li>
            <li
              v-for="(reason, index) in this.getCaseInformation.reasons"
              :key="index"
            >
              <p>{{ reason }}</p>
            </li>
          </ul>
          <ul>
            <li>
              <h4 class="reason-heading">Notes :</h4>
            </li>
            <li>
              <p>{{ getCaseInformation.notes }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="case-view-body">
      <div class="container-sm">
        <section id="view-case-screen">
          <PatientInformation></PatientInformation>
          <span class="case-creation__divider"></span>

          <CaseInformation></CaseInformation>
          <span class="case-creation__divider"></span>
          <div
            v-if="
              this.getCaseInformation &&
              this.getCaseInformation.case_types &&
              this.getCaseInformation.case_types.includes('TOXICOLOGY')
            "
          >
            <ToxicologyOrderChecklistView></ToxicologyOrderChecklistView>
          </div>
          <span class="case-creation__divider"></span>
          <TestInformation></TestInformation>

          <span class="case-creation__divider"></span>
          <div v-if="isCaseHavingAdditionalNotes">
            <AdditionalNotes></AdditionalNotes>
          </div>
          <span class="case-creation__divider"></span>

          <Medication></Medication>
          <div v-if="hasBillingType">
            <BillingInformation></BillingInformation>
            <span class="case-creation__divider"></span>
          </div>

          <TestAttachments></TestAttachments>
          <span class="case-creation__divider"></span>
   <div v-if="!this.getAuthenticatedUser.allow_unathorized_access">
        <ErequisitionForm></ErequisitionForm>
        </div>
          <span class="case-creation__divider"></span>
          <div v-if="checkCaseStatus">
            <CreateAccession></CreateAccession>
            <span class="case-creation__divider"></span>
          </div>
        </section>
      </div>
    </div>
    <AuditLogs
      v-if="orderAuditLogsPopup"
      v-on:close="orderAuditLogsPopup = false"
      :orderId="orderId"
    ></AuditLogs>
    <ResonForChange
      v-if="takeReasonDialog"
      v-on:close="takeReasonDialog = false"
      v-on:reasonSubmit="deleteCase"
      title="Reason for Archive"
    ></ResonForChange>
    <ReasonForStatusChange
      v-if="takeStatusChangeReasonDialog"
      v-on:close="takeStatusChangeReasonDialog = false"
      v-on:reasonSubmit="unsetOrderCompleteStatus"
      :width="40"
      :title="takeStatusChangeReasonDialogTitle"
    ></ReasonForStatusChange>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
const TestInformation = defineAsyncComponent(() =>
  import("@/components/orders/ViewTests")
);
const PatientInformation = defineAsyncComponent(() =>
  import("@/components/orders/PatientInformations")
);
const CaseInformation = defineAsyncComponent(() =>
  import("@/components/orders/CaseInformations")
);
const Medication = defineAsyncComponent(() =>
  import("@/components/orders/MedicationView")
);
const BillingInformation = defineAsyncComponent(() =>
  import("@/components/orders/BillingInformations")
);
const TestAttachments = defineAsyncComponent(() =>
  import("@/components/orders/TestAttachments")
);
const CreateAccession = defineAsyncComponent(() =>
  import("@/components/orders/CreateAccession")
);
const ErequisitionForm = defineAsyncComponent(() =>
  import("@/components/orders/Erequisition")
);
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const ReasonForStatusChange = defineAsyncComponent(() =>
  import("@/components/misc/OrderReasonForChange")
);
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
const ToxicologyOrderChecklistView = defineAsyncComponent(() =>
  import("@/components/orders/ToxicologyOrderChecklistView")
);
import AuditLogs from "@/components/cases/AllLogs";
const AdditionalNotes = defineAsyncComponent(() =>
  import("@/components/orders/AdditionalNotes")
);
const ChatApplication = defineAsyncComponent(() =>
  import("@/components/pendingClientOrders/ChatApplication")
);
export default {
  components: {
    TestInformation,
    PatientInformation,
    CaseInformation,
    Medication,
    BillingInformation,
    TestAttachments,
    CreateAccession,
    ErequisitionForm,
    ToxicologyOrderChecklistView,
    AuditLogs,
    AdditionalNotes,
    ChatApplication,
    ResonForChange,
    ReasonForStatusChange,
    TestAttachments,
  },
  data() {
    return {
      scrollPosition: null,
      loading: false,
      orderAuditLogsPopup: false,
      drawer: false,
      takeReasonDialog: false,
      takeStatusChangeReasonDialog: false,
      takeStatusChangeReasonDialogTitle: "",
    };
  },
  mixins: [UserPermissionsHelper],
  ...mapGetters("auth", ["getAuthenticatedUser"]),
  computed: {
    ...mapGetters("orders", [
      "getCaseInformation",
      "getShowMedication",
      "getUpdateOrderStatus",
    ]),
    checkCaseStatus() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.status === "COMPLETE"
      ) {
        return false;
      }
      if (
        this.getCaseInformation &&
        this.getCaseInformation.status === "ARCHIVED"
      ) {
        return false;
      }
      if (
        this.getCaseInformation &&
        this.getCaseInformation.status === "REJECTED"
      ) {
        return false;
      }
      if (
        this.getCaseInformation &&
        this.getCaseInformation.status === "PENDING"
      ) {
        return false;
      }
      return true;
    },
    isCaseCompleted() {
      if (!this.getCaseInformation) {
        return false;
      }
      return this.getCaseInformation.status === "COMPLETE";
    },
    hasBillingType() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.billing_type &&
        this.getCaseInformation.billing_type == "INSURANCE"
      ) {
        return true;
      }
      return false;
    },
    isCaseHavingAdditionalNotes() {
      if (this.getCaseInformation && this.getCaseInformation.physician_notes) {
        return true;
      }
      return false;
    },
    ...mapGetters("clientPendingOrders", ["getPendingOrderLogs"]),
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "TEST_RESULTS") {
          return "info";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else if (status == "REJECTED") {
          return "darkDanger";
        } else if (status == "PENDING") {
          return "danger";
        } else {
          return "";
        }
      };
    },
  },
  async mounted() {
    this.orderId = this.$route.params.order_id;
    await this.fetchOrderInformation();
    // await this.fetchOrderLogs();
    // await this.fetchClientPendingOrder();
    // Add Class
    this.toggleBodyClass("addClass", "fixedNavbarBody");
    // Scroll
    window.addEventListener("scroll", this.updateScroll);
    if (this.$route.query && this.$route.query.drawer) {
      this.drawer = true;
    }
  },
  async unmounted() {
    // Remove Class to body on scroll
    document.body.classList.remove("fixedNavbarOnComponent");
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    updateViewOrder(resp) {
      if (resp) {
        this.fetchOrderInformation();
      }
    },
    viewOrderAudit() {
      this.orderAuditLogsPopup = true;
    },
    goToEditForm() {
      this.$router.push({
        name: "Edit-Order-Info",
        params: { order_id: this.$route.params.order_id },
        query: this.$route.query,
      });
    },
    async onScroll() {
      // Get the scroll position, you can adjust this value based on your requirement
      const scrollPosition = window.scrollY;
      // Add a class to the body element based on the scroll position
      // For example, adding a class 'scrolled' when the user scrolls more than 100px
      if (scrollPosition > 1) {
        document.body.classList.add("fixedNavbarOnComponent");
      } else {
        document.body.classList.remove("fixedNavbarOnComponent");
      }
    },
    goToCaseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    async toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    async fetchOrderInformation() {
      try {
        this.loading = true;
        await this.$store.dispatch("orders/fetchCaseInformation", {
          order_id: this.$route.params.order_id,
        });
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchClientPendingOrder() {
      try {
        let params = {
          order_id: this.$route.params.order_id,
        };
        await this.$store.dispatch(
          "clientPendingOrders/fetchPendingOrderDetails",
          params
        );
      } catch (err) {
        console.log(err);
      }
    },
    async fetchOrderLogs() {
      try {
        this.loading = true;

        let params = {
          order_id: this.$route.params.order_id,
        };
        await this.$store.dispatch(
          "clientPendingOrders/fetchPendingOrderLogs",
          params
        );
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    closeDrawer() {
      this.drawer = false;
      this.$router.push({ query: { ...this.$route.query, drawer: undefined } });
      this.$emit("close", true);
    },
    async viewBarcode() {
      let urlData = this.$router.resolve({
        name: "OrderMultipleBarcodes",
        path: "/orders/multiple-barcodes",
        query: {
          order_ids: this.orderId,
        },
      });
      window.open(urlData.href, "_blank");
    },
    async changeStatus(command, OrderData) {
      try {
        if (command == OrderData.status) {
          return;
        }
        this.takeStatusChangeReasonDialogTitle = command;
        let params = {
          status: command,
          id: OrderData._id,
        };
        if (
          OrderData.status == "ACTIVE" ||
          OrderData.status == "PENDING" ||
          OrderData.status == "REJECTED"
        ) {
          this.unsetCompleteStatusChangeCase = OrderData._id;
          this.toStatus = command;
          this.askReasonOnUnsetCompletedStatus();
        } else {
          await this.updateStatus(params);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async unsetOrderCompleteStatus(data) {
      let params = {
        id: this.unsetCompleteStatusChangeCase,
        status: this.toStatus,
        notes: data.notes,
      };
      if (data.reasons && data.reasons.length > 0) {
        params.reasons = data.reasons;
      }
      await this.updateStatus(params);
    },
    async askReasonOnUnsetCompletedStatus() {
      this.takeStatusChangeReasonDialog = true;
    },
    async updateStatus(params) {
      try {
        this.loading = true;
        await this.$store.dispatch("orders/changeOrderStatus", params, {
          root: true,
        });
        if (this.getUpdateOrderStatus && this.getUpdateOrderStatus.success) {
          this.$notify({
            type: "success",
            title: "Success",
            message: this.getUpdateOrderStatus.message,
          });
          window.location.reload();
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
#generate-barcode-button {
  background: linear-gradient(79.26deg, #f24a55 -13.43%, #0a5da6 137.71%);
  color: white;
  border-radius: 7px;
  padding: 6px 20px;
  border: none;
  font-weight: 600;
}
.case-view-body {
  .view-cases {
    &.search-btn {
      ul {
        padding-bottom: 10px;
        li {
          .search-with-filter-input {
            position: relative;
            .el-select {
              .el-input__inner {
                cursor: pointer;
                display: inline-flex;
                height: 35px;
                background: #ffffff;
                border: 1px solid #e0e0e0;
                box-shadow: none;
                color: #000;
                max-width: 158px;
                padding-left: 30px;
                border-radius: 6px;
                position: relative;
              }
              .el-input__suffix {
                background: #0a5da6;
                border-radius: 0 5px 5px 0;
                right: 0;
                height: 97%;
              }
            }
            .search-icon {
              position: absolute;
              top: 17px;
              left: 7px;
              bottom: 199px;
              width: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          .search-accession {
            position: relative;
            .el-input {
              .el-input__inner {
                min-height: 35px;
                border-radius: 5px;
                padding-right: 20px;
                height: 35px;
              }
            }
            .search-icon {
              position: absolute;
              right: 5px;
              top: 7px;
              width: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }
  }
  .case-creation__card {
    .edit-view {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .view-cases {
      .el-input__inner {
        height: 30px;
      }
      .value {
        color: #0a2342;
        font-size: 13px;
        font-weight: 500;
      }
    }

    .case-creation__heading {
      .btn {
        min-height: 30px;
        .edit-icon {
          display: flex;
          align-items: center;
          margin-right: 10px;
          p {
            color: #828282;
          }
        }
        margin: 0;
        padding: 0;
        border: none;
        img {
          margin-right: 6px;
          width: 15px;
          height: 15px;
        }
        &:focus {
          background-color: #fff;
        }
        &:hover {
          background-color: #fff;
        }
      }
    }
  }
  .case-creation__footer {
    .look-up-button {
      background: #273480;
      border-radius: 5px;
      color: #ffffff;
      font-weight: 600;
      padding: 8px 19px 8px 19px;
      min-height: 20px;
    }
  }
}
.order-status-reason {
  margin-bottom: 5px;
  .bg-white {
    background: #fff;
    padding: 10px;
    border-radius: 6.40567px;
  }
  ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    li {
      position: relative;
      &:not(:last-child) {
        p {
          &:after {
            content: ",";
          }
          color: #333;
        }
      }
      .reason-heading {
        text-transform: uppercase;
        color: #333;
        margin-right: 0;
        font-size: 13px;
        color: #f24a55;
      }
      p {
        font-size: 13px;
        font-weight: 500;
        margin: 0;
        line-height: 1.5;
      }

      &:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
}
.case-status {
  height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  justify-content: space-between;
  li {
    button {
      cursor: default;
    }
  }
}
</style>
